const state = {
  exibir_apenas_combinacoes: false,
};

const getters = {
  exibir_apenas_combinacoes(state) {
    return state.exibir_apenas_combinacoes
  },
}

const mutations = {
  exibir_apenas_combinacoes(state, valor){
    state.exibir_apenas_combinacoes = valor
  },
}

const actions = {
  exibir_apenas_combinacoes: ({ commit }, valor) => {
    commit("exibir_apenas_combinacoes", valor)
  },
}

export default { namespaced: true, state, mutations, getters, actions }
